// GlobalJackpotWinnerPopup.js
import React from "react";
import styled from "styled-components";
import { Window, WindowHeader, WindowContent, Button } from "react95";

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const PopupWrapper = styled.div`
  max-width: 400px;
`;

const Center = styled.div`
  text-align: center;
  margin: 12px 0;
`;

/**
 * Dumb UI-only component.
 * The parent (NotificationContext / ProfilePage) owns the real
 * `claimGlobalJackpot()` function and passes it in via `onClaim`.
 */
const GlobalJackpotWinnerPopup = ({
  winningTicket,
  isWinner,
  onClaim,
  onClose,
  claiming = false, // pass this prop if you want a spinner / disabled state
}) => (
  <Overlay>
    <PopupWrapper>
      <Window>
        <WindowHeader>
          Global_Jackpot_Winner.eXe
          <span style={{ marginLeft: "auto" }}>
            <Button square onClick={onClose}>
              X
            </Button>
          </span>
        </WindowHeader>

        <WindowContent>
          <Center>
            <p>The winning ticket number is</p>
            <p style={{ fontSize: "2rem", fontWeight: "bold", margin: 0 }}>
              #{winningTicket}
            </p>

            <Button
              primary
              disabled={!isWinner || claiming}
              onClick={onClaim}
              style={{ width: "90%", marginTop: 16 }}
            >
              {!isWinner
                ? "Only the winner can claim"
                : claiming
                ? "Claiming…"
                : "Claim prize"}
            </Button>
          </Center>
        </WindowContent>
      </Window>
    </PopupWrapper>
  </Overlay>
);

export default GlobalJackpotWinnerPopup;
